import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

function BSModal({ isOpen, handleHideModal, title, body }) {
  const handleClose = () => {
    handleHideModal && handleHideModal()
  }

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="small">
      <Modal.Header title={title} />
      <Modal.Body>
        <p>{body}</p>
      </Modal.Body>
      <Modal.Footer
        cancelBtnText="OK"
        onlyCancel={true}
        onClose={handleClose}
      />
    </Modal>
  )
}

BSModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  handleHideModal: PropTypes.func,
}

export default BSModal
